
<template lang="pug">
  .helpbody.modal.component
    
    Span.text(v-if="title=='What is BlueFaucet'") {{ $t("What is BlueFaucet-detail") }}
    
    Span(v-if="title=='How much does it cost'") 
      p {{ $t("BlueFaucet offers multiple package options catered to your business needs and budget.  We offer our new users a 30 days free trial and members less than 50 free of charge.  Other options include:") }}
      ul
        li {{$t("Basic package is free,")}}
        li {{$t("Value Package is $14.99 per month")}}
        li {{$t("Pro Package is $19.99 per month")}}
        li {{$t("Recommendation is $5 per month per zip code plus 3% success fee.")}}
      p {{$t("Please check the Price and Functions for more detailed information.")}}

    Span(v-if="title=='Who needs BlueFaucet'") 
      p {{$t("BlueFaucet provides an ecosystem dedicated to servicing both local businesses and customers in the marketplace.  Small and local business owners can use BlueFaucet to market and better manage their service appointments and orders.  Customers have the flexibility to search services through the BlueFaucet directory and make or cancel appointments/orders through a few simple clicks.")}}

    Span(v-if="title=='How to make a reservation'") 
      p {{$t("Once the customer finds the favorite store from the BlueFaucet merchant directory, it takes only a few simple steps to make a reservation.")}}
      ol
        li {{$t("Click on the Store or Business")}}
        li {{$t("Scroll down to Services Offered")}}
        li {{$t("Select the Service that you are requesting a reservation")}}
        li {{$t("In the Popup window, confirm the service, duration, price, and details.  Then click on Select Date/Time to make your reservation")}}
        li {{$t("Select the date and time that best fits your schedule")}}
        li {{$t("Click Confirm and you will receive confirmation popup that the reservation was made with the merchant")}}

    Span(v-if="title=='Who can become a merchant'") 
      p {{ $t("Any individual or small business.  BlueFaucet’s goal is to empower local businesses to be able to succeed in the market.")}}

    Span(v-if="title=='Customer Services'") 
      p {{$t("We have a dedicated customer services team standing by to assist with any questions or issues via email.  Please contact us at")}} 
      p CS@bluefaucet.com.  
    
    Span(v-if="title=='How does the Invitation work'") 
      p {{$t("Each invitation has an embedded unique ID code in the link or QR Code which allows the system to identify who invited the customers or merchants.  Once the customer or merchant clicks on the unique url, the system will automatically attach the merchant or sales name to it.  You can also copy your QR Code or link to your Facebook, Twitter, SMS and other social media apps to invite your friends and customers to join your membership.")}}

    span(v-if="title=='How do I offer my service'")
      ol
        li {{$t("To get started, first register an account at app.bluefaucet.com and select the option to become a merchant.")}}
        li {{$t("Customize your dedicated merchant page with descriptions of services and pictures")}}
        li {{$t("Invite your customers to join your membership")}}


    span(v-if="title=='How to invite customers to join my membership'")
      p {{$t("BlueFaucet provides many ways to market to your customers and target the marketplace.")}}
      ol
        li {{$t("Via Email:  First click on Customers.  Enter your customer email address and click Send Invitation")}}
        li {{$t("Via SMS: You can also send the invitation via SMS by clicking on Copy and paste invitation to SMS to your customers")}}
        li {{$t("Via QR Code:  Your customers can scan your unique QR Code when they walk into your store")}}
        li {{$t("Via mailing list: If you already have a customers database, you can use Bulk Import the list and BlueFaucet can mass email to your customers through the mailing list")}}

    span(v-if="title=='How does BlueFaucet drive more business for merchants'")
      p {{$t("There are many tools for merchants to use to help drive business:")}}
      ol
        li {{$t("Marketing: Our focused tools for you to communicate effectively with your customers. We have advanced functionality to target your customer membership and send coupons or promotions directly to your members’ mobile phone")}}
        li {{$t("Recommendation*: BlueFaucet can recommend your services to customers who are in search of specific services within their search criteria")}} 
        li {{$t("Smart Assistant: Smart Assistant can automatically invite your customers back for service as a friendly reminder when there has been limited activity online")}}
        li {{$t("Orders: You can invite your customers back directly")}}
      p *{{$t("Recommendation service is not included in monthly subscription service.")}}

    span(v-if="title=='What is the BlueFaucet Sales Program'")
      ol  
        li {{$t("BlueFaucet offers a Sales Program to all our customers who refer merchants to us.  To qualify, merchants must sign up for a paid package (Value Package or Pro Package).")}}
        li {{$t("Sales commission range around $30 or $40 per paid merchant, depending on the Package the merchant selects.")}}
        li {{$t("Please see Sales Agreement for details on how the Sales Program works.")}}

    span(v-if="title=='What should I do if I did not find my favorite store in the list'")
      p {{$t("BlueFaucet’s goal is to have a comprehensive list of stores and merchants and become your one stop shop for all services.  If you do not find the store in our directory, you can click on Invite Merchant to invite the merchant.  Once the merchant signs up and becomes a paid subscriber, we will provide commission as part of our Sales Program.  Please see Sales Program for details.")}}

    span(v-if="title=='Referral Program'")
      p {{$t("If you would like to refer your merchants to your friend, you can go to the merchant’s dedicated BlueFaucet page, and click on the Refer A Friend.  As a thank you offer for the referral, many of the merchants will offer you a coupon.")}}

    span(v-if="title=='What is Sales job function'")
      ol
        li {{$t("The sales main job function is to send Invitation to the merchants.")}}
        li {{$t("After the invitation has been sent, you can see the merchants’ status in the Sales Page.")}}
        li {{$t("The Sales Page will contain dashboard showing your earning, merchant invitation status, etc.")}}


</template>

<script>
  import { View } from '@/mixins/view'

  export default {
    name: 'helpbody.modal.component',

    props: {
      title: {type: String, default: ""}
    }

  }
</script>

<style scoped lang='stylus'>
  .helpbody
    line-height 1.5
    font-size 1.2em
  p  
    margin-bottom 10px
    margin-top 10px
  ul
    list-style-type: disc
    margin-left 20px
  ol
    list-style-type: decimal
    margin-left 20px
</style>